import { fieldValidations } from "./fieldValidations";

export default {
  victimOfOffender: {
    value: "",
    legend: "Is the minor a victim of the inmate they wish to visit?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: true,
    fatalVal: "yes",
    isRequired: true
  },
  felonyConviction: {
    value: "",
    legend: "Has the minor ever been convicted of a felony?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: false,
    fatalVal: "yes",
    isRequired: true
  },
  courtSupervision: {
    value: "",
    legend: "Is the minor currently under active court supervision?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: true,
    fatalVal: "yes",
    isRequired: true
  },
  gangAssociation: {
    value: "",
    legend:
      "Is the minor currently or has the minor previously been a member of a gang, racial supremacy group, or another similar organization as defined in the Code of Virginia §18.2-46.1?",
    tipTitle: "Code of Virginia §18.2-46.1",
    info:
      "“Criminal street gang” means any ongoing organizaton, associaton, or group of three or more persons, whether formal or informal, i) which has one of its primary objectives or activities the commission of one or more criminal activities; ii) which has an identifiable name or identifying sign or symbol; and iii) whose members individually or collectively have engaged in the commission of, attempt to commit, conspiracy to commit, or solicitation of two or more predictable criminal acts, at least one of which is an act of violence, provided such acts were not part of a common act or transaction.",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: true,
    fatalVal: "yes",
    isRequired: true
  },
  DOB: {
    value: "",
    label: "Date of Birth",
    validation: fieldValidations.isMinor,
    errMessage: "",
    className: "",
    isRequired: true
  },
  firstName: {
    value: "",
    label: "Minor's Legal First Name",
    maxLength: "50",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  middleName: {
    value: "",
    label: "Minor's Legal Middle Name",
    maxLength: "50",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  lastName: {
    value: "",
    label: "Minor's Legal Last Name",
    maxLength: "50",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  ssn: {
    value: "",
    label: "Last 4 of Minor's SSN",
    validation: fieldValidations.isLastFourSsn,
    errMessage: "",
    className: "",
    maxLength: 4,
    isRequired: true
  },
  placeOfBirth: {
    value: "",
    label: "Place of Birth",
    maxLength: "100",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    placeholder: "City/County, State, and Country",
    className: "",
    isRequired: true
  },
  race: {
    value: "",
    legend: "Race ",
    options: [
      { label: "American Indian or Alaskan Native", value: "15" },
      { label: "Asian or Pacific Islander", value: "16" },
      { label: "Black", value: "17" },
      { label: "Unknown", value: "19" },
      { label: "White", value: "18" }
    ],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  sex: {
    value: "",
    legend: "Sex ",
    options: [{ label: "Female", value: "13" }, { label: "Male", value: "12" }],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  parentLegalGuardian: {
    value: true,
    errMessage: "",
    className: "",
    isRequired: true,
    validation: fieldValidations.isTrue
  }
};



// WEBPACK FOOTER //
// ./src/utils/minorFormFields.js